export const multipleLine = {
  width: '100%',
  height: '168px',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '10px',
  bg: 'grey/dark/background',
  fontFamily: 'regular',
  fontSize: '16px',
  letterSpacing: '0.5px',
  textAlign: 'left',
  color: 'white',
  variants: {
    positive: {
      states: {
        '&:hover': {},
        '&:focus': {},
        '&:read-only': {},
        '&::placeholder': {
          color: 'white',
        },
      },
    },
  },
};
